import { ControlFacet } from '../models/controls/ControlFacet';

export const itemsViewControl = new ControlFacet<{
  itemsScopeItemKey: string;
  itemKey: string | undefined;
}, {
    pinnedItemsView: JSX.Element | undefined;
    additionalLayouts: JSX.Element[] | undefined;
  }>('itemsViewControl');
